import { render, staticRenderFns } from "./JFormattedInput.vue?vue&type=template&id=6dbcd96f&scoped=true&"
import script from "./JFormattedInput.vue?vue&type=script&lang=ts&"
export * from "./JFormattedInput.vue?vue&type=script&lang=ts&"
import style0 from "./JFormattedInput.vue?vue&type=style&index=0&id=6dbcd96f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbcd96f",
  null
  
)

export default component.exports